import { useEffect, useState } from "react";
import {
    format,
    parseISO,
    isWithinInterval,
    startOfToday,
    parse,
    differenceInMinutes,
    startOfWeek,
    endOfWeek,
    isToday,
    addDays,
} from "date-fns";
import React from "react";
import ManagerNav from "./managernav";
import TaskManagerRole from "./taskmanagerrole";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import { CheckBadgeIcon, ChevronDownIcon, ClockIcon, HandRaisedIcon, SunIcon } from "@heroicons/react/20/solid";
import ShiftCalendar from "./shiftcalendar";
import TaskTraining from "./tasktraining";
import OverTimeRequests from "./overtimerequests";
import Bids from "./bids";
import HolidayGraph from "./holidaygraph";


export default function OvertimeManager() {
    const [shifts, setShifts] = useState([]);
    const [dateRange, setDateRange] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [budgetTableData, setBudgetTableData] = useState([]);
    const [overTime, setOverTime] = useState(null);
        const [overTimeInputs, setOverTimeInputs] = useState({});
    const [requests, setRequests] = useState([]);
    const [budgetCalc, setBudgetCalc] = useState(null);
    const [activeTab, setActiveTab] = useState("bids");
    const [projects, setProjects] = useState([]);

    


    const user = useContext(AuthContext);



    const formatTime = (time) => time.slice(0, 5);

    const isDayOff = (startTime, endTime) =>
        startTime === "00:00:00" && endTime === "00:00:00";

    const calculateHoursWorked = (startTime, endTime) => {
        if (isDayOff(startTime, endTime)) return 0;
        const start = parse(startTime, "HH:mm:ss", new Date());
        const end = parse(endTime, "HH:mm:ss", new Date());
        const minutesWorked = differenceInMinutes(end, start);
        return minutesWorked / 60;
    };

    console.log("Fetching tasks for date:", dateRange);

    useEffect(() => {
        const fetchBudgets = async () => {
            try {
                const response = await fetch("https://api.insightos.co.uk/api/operations", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                });
                if (!response.ok) {
                    throw new Error("Failed to fetch budgets");
                }
                const data = await response.json();
                console.log("Operations:", data);

 const budgets = data.data

        const MonthlyBudget = budgets[0].Budget

        const daysOpen = budgets[0].DaysOpen; // per week 

        const dailyBudget = MonthlyBudget / (daysOpen * 4); // Assuming 4 weeks in a month





       



                setBudgetTableData(dailyBudget);
            } catch (error) {
                console.error("Failed to fetch budgets:", error);
            }
        };
        fetchBudgets();
    }, []);

    useEffect(() => {
        const fetchShifts = async () => {
            try {
                

                const response = await fetch("https://api.insightos.co.uk/api/shifts", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                });
                if (!response.ok) throw new Error("Failed to fetch shifts");
                const data = await response.json();

                const responseStaff = await fetch("https://api.insightos.co.uk/api/staff", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                });

                const date = format(new Date(), "yyyy-MM-dd");


               


                if (!responseStaff.ok) throw new Error("Failed to fetch staff");
                const dataStaff = await responseStaff.json();

                const shiftsData = data.data.map((shift) => {
                    const staff = dataStaff.data.find(
                        (staff) => staff.id === shift.StaffId
                    );
                    return { ...shift, staff };
                });

                setShifts(shiftsData);
                updateDateRange(shiftsData);
            } catch (error) {
                console.error("Error fetching shifts:", error);
            }
        };

        fetchShifts();
    }, []);

    const updateDateRange = (shiftsData) => {
        const today = startOfToday();
        const startOfWeekDate = today; // Start from today
        const endOfWeekDate = addDays(today, 7); // End exactly 7 days later
        
        const dates = shiftsData
            .map((shift) => parseISO(shift.ShiftDate))
            .filter((date) =>
                isWithinInterval(date, { start: startOfWeekDate, end: endOfWeekDate })
            )
            .reduce((acc, date) => {
                const formattedDate = format(date, "dd-MM-yy");
                if (!acc.includes(formattedDate)) acc.push(formattedDate);
                return acc;
            }, []);
        setDateRange(dates);
    };

    const filterShifts = () => {
        const today = startOfToday();
        const startOfWeekDate = today; // Start from today
        const endOfWeekDate = addDays(today, 7); // End exactly 7 days later
        return shifts.filter((shift) =>
            isWithinInterval(parseISO(shift.ShiftDate), { start: startOfWeekDate, end: endOfWeekDate })
        );
    };

    const groupedShifts = () => {
        const shiftsByDateAndStaff = {};
    
        filterShifts()
            .filter(shift => shift.Sick !== 1 && shift.Holiday !== 1) // Exclude sick or holiday shifts
            .forEach((shift) => {
                const staffName = shift.staff.Name;
                const role = shift.staff.Role;
                const department = shift.staff.Department;
                const shiftDate = format(parseISO(shift.ShiftDate), "dd-MM-yy");
    
                const timeRange = isDayOff(shift.StartTime, shift.EndTime)
                    ? "Day Off"
                    : `${formatTime(shift.StartTime)} - ${formatTime(shift.EndTime)}`;
    
                if (!shiftsByDateAndStaff[staffName]) {
                    shiftsByDateAndStaff[staffName] = {};
                }
    
                shiftsByDateAndStaff[staffName][shiftDate] = {
                    timeRange,
                    hoursWorked: calculateHoursWorked(shift.StartTime, shift.EndTime),
                    HourlyRate: shift.staff.HourlyRate,
                    Role: role,
                    Department : department
                };
            });
    
        return shiftsByDateAndStaff;
    };
    
    const shiftsGrouped = groupedShifts();

    const dailyStaffCosts = dateRange.reduce((acc, date) => {
        acc[date] = 0;
        Object.values(shiftsGrouped).forEach((staffShifts) => {
            // If the staff member isSick or onHoliday, don't include their cost

            
            const shiftDetails = staffShifts[date];
            if (shiftDetails) {
                acc[date] += shiftDetails.hoursWorked * shiftDetails.HourlyRate;
            }
        });
        return acc;
    }, {});

    const sortedDates = [...dateRange].sort((a, b) => {
        const dateA = parse(a, "dd-MM-yy", new Date());
        const dateB = parse(b, "dd-MM-yy", new Date());
        return dateA - dateB;
    });

    const uniqueRoles = new Set();
    Object.values(shiftsGrouped).forEach((staffShifts) => {
        Object.values(staffShifts).forEach((shift) => {
            uniqueRoles.add(shift.Role);
        });
    });

    const departments = Array.from(
      new Set(
        Object.values(shiftsGrouped)
          .flatMap(staffShifts => Object.values(staffShifts).map(shift => shift.Department))
      )
    );
   
    const roles = Array.from(uniqueRoles);

    console.log("Roles:", roles);

    


    const dailyRoleCosts = sortedDates.map((date) => {
        const roleCost = {};
        roles.forEach((role) => {
            roleCost[role] = 0;
        });
        Object.values(shiftsGrouped).forEach((staffShifts) => {
            const shiftDetails = staffShifts[date];
            if (shiftDetails) {
                const role = shiftDetails.Role;
                roleCost[role] += shiftDetails.hoursWorked * shiftDetails.HourlyRate;
            }

            // I then want to get what department the staff is in and then get the budget for that department

            
            
        });
        const total = Object.values(roleCost).reduce((sum, cost) => sum + cost, 0);
        return { date, roleCost, total };
    });

    const getHourlyRateForRole = (date, role) => {
        // First try to find the rate for this specific date and role
        let rate = null;
        Object.values(shiftsGrouped).forEach((staffShifts) => {
            const shiftDetails = staffShifts[date];
            if (shiftDetails && shiftDetails.Role === role && rate === null) {
                rate = shiftDetails.HourlyRate;
            }
        });
        
        // If no rate found for this date, look for the role in any date
        if (rate === null) {
            Object.values(shiftsGrouped).forEach((staffShifts) => {
                Object.values(staffShifts).forEach(shiftDetails => {
                    if (shiftDetails.Role === role && rate === null) {
                        rate = shiftDetails.HourlyRate;
                    }
                });
            });
        }
        
        // If still no rate, provide a default based on average of other roles
        if (rate === null) {
            let totalRates = 0;
            let count = 0;
            Object.values(shiftsGrouped).forEach((staffShifts) => {
                Object.values(staffShifts).forEach(shiftDetails => {
                    if (shiftDetails.HourlyRate) {
                        totalRates += parseFloat(shiftDetails.HourlyRate);
                        count++;
                    }
                });
            });
            rate = count > 0 ? totalRates / count : 10; // Default to £10 if no rates found
        }
        
        return rate;
    };

   
      






    if (selectedDate) {
        const formattedDateForAPI = format(
            parse(selectedDate, "dd-MM-yy", new Date()),
            "yyyy-MM-dd"
        );
        console.log("Formatted date for API:", formattedDateForAPI);
        return <ShiftCalendar 
            selectedDate={formattedDateForAPI} 
            onBack={() => setSelectedDate(null)}
        />;
    }


   
      
    const handleRequest = async (date) => {
        // Format the date to yyyy-MM-dd
        const formattedDate = format(parse(date, "dd-MM-yy", new Date()), "yyyy-MM-dd");
      
        console.log("Requesting Overtime for:", date);
      
        const hours = parseFloat(overTimeInputs[date]?.hours || 0);
        const reason = overTimeInputs[date]?.reason || "";
        const role = overTimeInputs[date]?.role;
        const department = overTimeInputs[date]?.department;

        const project = overTimeInputs[date]?.project;
      
        // Validate required inputs before proceeding
        if (!hours || hours <= 0) {
          alert("Please enter a valid number of hours.");
          return;
        }
      
        if (!role) {
          alert("Please select a role.");
          return;
        }
      
        // Calculate budget before making the request
        const budgetCalc = handleCalculate(date, hours, role);
      
        // If overtime request exceeds budget, prevent submission
        if (budgetCalc.exceedsBudget) {
          alert(`Request exceeds budget by £${budgetCalc.overBudgetBy.toFixed(2)}. Reduce hours or choose a different role.`);
          return;
        }
      
        // Create the request object
        const request = {
          content: `Overtime Request for my ${department} on ${date} for ${hours} hours. Reason: ${reason}`,
          from: user.email,
          date: formattedDate,
          hours,
          reason,
          role,
          project,
          department
        };
      
        try {
          const response = await fetch(`https://api.insightos.co.uk/api/requests`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(request),
          });
      
          if (response.ok) {
            alert("Request Sent Successfully!");
            window.location.reload();
          } else {
            const errorMessage = await response.text();
            alert(`Failed to send request: ${errorMessage}`);
          }
        } catch (error) {
          console.error("Error sending request:", error);
          alert("An error occurred while sending the request. Please try again.");
        }
      };
      

    const handleCalculate = (date, requestedHours, role) => {
        console.log("Calculating Overtime for:", date, requestedHours, role);
    
        // Ensure `date` is properly parsed into a Date object
        const dateObj = parse(date, "dd-MM-yy", new Date());
        if (isNaN(dateObj)) {
            console.error("Invalid date format:", date);
            return { remainingBudget: 0, totalOvertimeCost: 0, availableOvertimeHours: 0, exceedsBudget: false, overBudgetBy: 0 };
        }
    
        // Format date correctly for comparison
        const formattedDate = format(dateObj, "yyyy-MM-dd");
        const dayOfWeek = format(dateObj, "EEEE");
        console.log("Day of the week:", dayOfWeek);
    
        // Filter shifts by the formatted date
        const shiftsForDate = shifts.filter((shift) => {
            const shiftDate = format(parseISO(shift.ShiftDate), "yyyy-MM-dd");
            return shiftDate === formattedDate;
        });
    
        if (shiftsForDate.length === 0) {
            console.log(`No shifts found for any role on ${formattedDate}`);
            return { remainingBudget: 0, totalOvertimeCost: 0, availableOvertimeHours: 0, exceedsBudget: false, overBudgetBy: 0 };
        }
    
        // Filter shifts by role
        const shiftsForRole = shiftsForDate.filter((shift) => shift.staff.Role === role);
        if (shiftsForRole.length === 0) {
            console.log(`No shifts found for role ${role} on ${formattedDate}`);
            return { remainingBudget: 0, totalOvertimeCost: 0, availableOvertimeHours: 0, exceedsBudget: false, overBudgetBy: 0 };
        }
    
        let totalWorkedCost = 0;
        shiftsForDate.forEach((shift) => {
            const start = new Date(`1970-01-01T${shift.StartTime}Z`);
            const end = new Date(`1970-01-01T${shift.EndTime}Z`);
            const shiftDuration = (end - start) / (1000 * 60 * 60);
            const rate = parseFloat(shift.staff.HourlyRate);
            if (!isNaN(shiftDuration) && !isNaN(rate)) {
                totalWorkedCost += shiftDuration * rate;
            }
        });
    
        console.log(`Total cost of hours worked on ${formattedDate}: £${totalWorkedCost.toFixed(2)}`);
    
        // Find the budget for the given day of the week
        const dailyBudget = budgetTableData
    
        const remainingBudget = dailyBudget - totalWorkedCost;
        console.log(`Remaining Budget for overtime on ${dayOfWeek}: £${remainingBudget.toFixed(2)}`);
    
        const hourlyRate = parseFloat(shiftsForRole[0].staff.HourlyRate);
        const requestedOvertimeCost = parseFloat(requestedHours) * hourlyRate;
        console.log(`Requested Overtime Cost: £${requestedOvertimeCost.toFixed(2)}`);
    
        const availableOvertimeHours = remainingBudget / hourlyRate;
        console.log(`Available overtime hours within budget for ${dayOfWeek}: ${availableOvertimeHours.toFixed(2)} hours`);
    
        const exceedsBudget = requestedOvertimeCost > remainingBudget;
        console.log(`Exceeds Budget: ${exceedsBudget}`);
        const overBudgetBy = requestedOvertimeCost - remainingBudget;
    
        return {
            totalOvertimeCost: requestedOvertimeCost,
            remainingBudget,
            availableOvertimeHours,
            exceedsBudget,
            overBudgetBy,
            hourlyRate,
        };
    };
    

  





useEffect(() => {

    const fetchProjects = async () => {

        try {

          const response = await fetch("https://api.insightos.co.uk/api/getovertimeproject", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          });

          if (!response.ok) throw new Error("Failed to fetch projects");

          const data = await response.json();

          console.log("Projects:", data);

          setProjects(data.data);

        } catch (error) {

          console.error("Failed to fetch projects:", error);

        }


      };


      fetchProjects();


}, []);





  // 



    console.log(overTimeInputs)

















        



    return (
        <div>
            <ManagerNav />
            <header></header>
        <div className="flex w-full flex-col gap-4 bg-gradient-to-br from-slate-50 via-sky-50 to-indigo-100 px-2 py-3 lg:flex-row lg:gap-5 sm:px-3 sm:py-4">
        <div className="w-full rounded-3xl border border-white/35 bg-white/75 px-2 shadow-[0_16px_40px_rgba(15,23,42,0.16)] backdrop-blur-xl sm:px-4 lg:ml-2 lg:w-2/3">
        <h3 className="mt-4 mb-4 rounded-2xl bg-gradient-to-r from-indigo-900/90 via-sky-700/85 to-emerald-500/80 px-4 py-3 text-lg font-semibold text-white shadow-[0_14px_35px_rgba(15,23,42,0.2)]">Overtime Requests</h3>
            
<div className="mt-5">
  <OverTimeRequests shifts = {shifts} budgetTableData={budgetTableData} />
</div>





{/* Show the button only if there are 2 or more requests */}




                <div className="px-2 py-3 sm:px-4 sm:py-5">
                    <h2 className="text-lg font-semibold text-gray-900">Budget Table</h2>
                  <div className="mt-4 overflow-x-auto rounded-2xl border border-white/35 bg-white/85 shadow-[0_14px_35px_rgba(15,23,42,0.14)] backdrop-blur-xl">
                        <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gradient-to-r from-indigo-100/80 via-sky-100/70 to-emerald-100/70">
                                <tr>
                                    <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                        Date
                                    </th>
                                    <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                        Budget
                                    </th>
                                    {roles.map((role) => (
                                        <React.Fragment key={role}>
                                            <th className="px-2 py-2 mb-3 text-left text-xs sm:text-sm font-medium text-gray-900">
                                                {role} Cost
                                            </th>
                                            <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                                {role} OT Hours
                                            </th>
                                        </React.Fragment>
                                    ))}
                                    <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                        Total Cost
                                    </th>
                                    <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                        Savings
                                    </th>
                                    <th className="px-2 py-2 text-left text-xs sm:text-sm font-medium text-gray-900">
                                        Actions
                                    </th>
                                </tr>
                            </thead>




<tbody className="bg-white divide-y divide-gray-200">
  {sortedDates.map((date) => {
    // Convert the date string to a Date object
    const dateObj = parse(date, "dd-MM-yy", new Date());
    // Determine dynamic classes based on whether the date is today
    const rowClasses = isToday(dateObj)
      ? "bg-emerald-100"
      : "bg-purple-50";

    // Format the date for display
    const displayDate = format(dateObj, "EEEE, MMMM d");
    const fullDisplayDate = format(dateObj, "EEEE, MMMM d, yyyy");

    // Find related budget and cost data
    const dailyBudget = budgetTableData
    const dailyCost = dailyStaffCosts[date] || 0;
    const savings = dailyBudget - dailyCost;

    return (
      <tr key={date} className={`${rowClasses} even:bg-gray-50`}>
        <td className="px-2 py-2 whitespace-nowrap text-xs sm:text-sm font-medium text-gray-900">
          <span className="hidden sm:inline">{fullDisplayDate}</span>
          <span className="sm:hidden">{displayDate}</span>
        </td>
        <td className="px-2 py-2 whitespace-nowrap text-xs sm:text-sm text-black font-semibold">
          £{dailyBudget.toFixed(2)}
        </td>
        {roles.map((role) => {
          const cost = dailyRoleCosts.find(item => item.date === date)?.roleCost[role] || 0;
          const hourlyRate = getHourlyRateForRole(date, role);
          // Ensure we always have a valid hourly rate and calculate overtime hours
          const validHourlyRate = hourlyRate > 0 ? hourlyRate : 10; // Fallback to £10 if no rate
          const otHours = savings > 0 ? savings / validHourlyRate : 0;
          
          console.log(`Date: ${date}, Role: ${role}, Savings: £${savings}, Rate: £${validHourlyRate}, OT Hours: ${otHours}`);
          
          return (
            <React.Fragment key={role}>
              <td className="px-2 py-2 whitespace-nowrap text-xs sm:text-sm text-indigo-600">
                £{cost.toFixed(2)}
              </td>
              <td className="px-2 py-2 whitespace-nowrap text-xs sm:text-sm text-sky-500 text-center">
                {otHours > 0 ? otHours.toFixed(2) : "0.00"}
              </td>
            </React.Fragment>
          );
        })}
        <td className="px-2 py-2 whitespace-nowrap text-xs sm:text-sm text-gray-500">
          £{dailyCost.toFixed(2)}
        </td>
        <td className={`px-2 py-2 whitespace-nowrap text-xs sm:text-sm ${savings >= 0 ? "text-emerald-500" : "text-red-500"}`}>
          {savings >= 0 ? "+" : "-"}£{Math.abs(savings).toFixed(2)}
        </td>
        <td className="px-2 py-2 text-xs sm:text-sm text-gray-500">
          {(user.access === "admin" || user.access === "manager") && (
        <div>
        <div className="flex flex-col sm:flex-row items-center gap-2">
          <input
            type="number"
            className="w-full rounded-2xl border border-white/45 bg-white/85 px-2 py-1 text-xs font-semibold text-gray-900 shadow-[0_10px_20px_rgba(15,23,42,0.1)] backdrop-blur-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:w-auto sm:px-3 sm:py-2 sm:text-sm"
            placeholder="Hours"
            value={overTimeInputs[date]?.hours || ""}
            onChange={(e) =>
              setOverTimeInputs((prev) => ({
                ...prev,
                [date]: {
                  ...prev[date],
                  hours: e.target.value,
                },
              }))
            }
          />
          <input
            type="text"
            className="w-full rounded-2xl border border-white/45 bg-white/85 px-2 py-1 text-xs font-semibold text-gray-900 shadow-[0_10px_20px_rgba(15,23,42,0.1)] backdrop-blur-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:w-auto sm:px-3 sm:py-2 sm:text-sm"
            placeholder="Reason"
            value={overTimeInputs[date]?.reason || ""}
            onChange={(e) =>
              setOverTimeInputs((prev) => ({
                ...prev,
                [date]: {
                  ...prev[date],
                  reason: e.target.value,
                },
              }))
            }
          />
          <div className="relative w-full sm:w-auto">
            <select
              id="overTimeRole"
              name="overTimeRole"
              value={overTimeInputs[date]?.role || ""}
              onChange={(e) =>
                setOverTimeInputs((prev) => ({
                  ...prev,
                  [date]: {
                    ...prev[date],
                    role: e.target.value,
                  },
                }))
              }
              className="w-full appearance-none rounded-2xl border border-white/45 bg-white/85 py-1 px-2 text-xs text-gray-900 shadow-[0_10px_20px_rgba(15,23,42,0.1)] backdrop-blur-xl outline-none focus:outline focus:outline-2 focus:outline-indigo-600 sm:py-1.5 sm:pl-3 sm:pr-8 sm:text-sm"
            >
              <option value="" disabled>
                Select role
              </option>
              {roles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500"
            />
          </div>

          <div className="relative w-full sm:w-auto">
            <select
              id="overTimeDepartment"
              name="overTimeDepartment"
              value={overTimeInputs[date]?.department || ""}
              onChange={(e) =>
                setOverTimeInputs((prev) => ({
                  ...prev,
                  [date]: {
                    ...prev[date],
                    department: e.target.value,
                  },
                }))
              }
              className="w-full appearance-none rounded-2xl border border-white/45 bg-white/85 py-1 px-2 text-xs text-gray-900 shadow-[0_10px_20px_rgba(15,23,42,0.1)] backdrop-blur-xl outline-none focus:outline focus:outline-2 focus:outline-indigo-600 sm:py-1.5 sm:pl-3 sm:pr-8 sm:text-sm"
            >
              <option value="" disabled>
                Select department
              </option>
              {departments.map((department) => (
                <option key={department} value={department}>
                  {department}
                </option>
              ))}
            </select>
            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500"
            />
          </div>
          <div className="relative w-full sm:w-auto">
            <select 
              id="overTimeProject"
              name="overTimeProject"
              value={overTimeInputs[date]?.project || ""}
              onChange={(e) =>
                setOverTimeInputs((prev) => ({
                  ...prev,
                  [date]: {
                    ...prev[date],
                    project: e.target.value,
                  },
                }))
              }
              className="w-full appearance-none rounded-2xl border border-white/45 bg-white/85 py-1 px-2 text-xs text-gray-900 shadow-[0_10px_20px_rgba(15,23,42,0.1)] backdrop-blur-xl outline-none focus:outline focus:outline-2 focus:outline-indigo-600 sm:py-1.5 sm:pl-3 sm:pr-8 sm:text-sm"
            > 
              <option value="" disabled>
                Select project
              </option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.Name}
                </option>
              ))}
            </select>

            <ChevronDownIcon
              aria-hidden="true"
              className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-500"
            />
          </div>


          <button
            onClick={() => handleRequest(date)}
            type="button"
            data-component="overtime-manager-form"
            data-time-saved="10"
            data-feature="submit_overtime_request_post"
            data-date={date}
            className="w-full rounded-2xl bg-gradient-to-br from-indigo-900/90 to-indigo-700/90 px-2 py-1 text-xs font-semibold text-white shadow-[0_12px_28px_rgba(49,46,129,0.3)] transition-all hover:from-indigo-800/95 hover:to-indigo-600/95 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:w-auto sm:px-3 sm:py-2 sm:text-sm"
          >
            Request
          </button>
        </div>
        {/* Conditional Message based on Budget Calculation */}
        {budgetCalc && (
          <div
            className={`mt-2 text-xs sm:text-sm font-semibold ${
              budgetCalc.exceedsBudget ? 'text-red-600' : 'text-green-600'
            }`}
          >
            {budgetCalc.exceedsBudget
              ? `Over budget by £${budgetCalc.overBudgetBy.toFixed(2)}`
              : 'Within Budget'}
          </div>
        )}
      </div>
          )}
        </td>
      </tr>
    );
  })}
</tbody>
</table>

                    </div>
                </div>
             




                
            </div>
            <div className="container mx-auto mt-4 w-full rounded-3xl border border-white/25 bg-gradient-to-br from-indigo-950 via-sky-800 to-emerald-600 p-3 shadow-[0_18px_45px_rgba(15,23,42,0.28)] lg:mt-0 lg:w-1/3">
      {/* Tabs Navigation */}
      <div className="flex flex-wrap mt-5 justify-center gap-2 sm:space-x-4 pb-2">
        <button
          className={`inline-flex items-center gap-x-2 rounded-2xl px-2 py-2 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-[0_10px_24px_rgba(15,23,42,0.22)] hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600
 ${
            activeTab === "bids" ? "bg-white/20 border border-white/30" : "bg-white/10 border border-white/20"
          }`}
          onClick={() => setActiveTab("bids")}
          data-component="overtime-manager-tabs"
          data-feature="view_overtime_bids"
        >
                    <HandRaisedIcon aria-hidden="true" className="-mr-0.5 size-4 sm:size-5" />

          Bids
        </button>

        <button
          className={`inline-flex items-center gap-x-2 rounded-2xl px-2 py-2 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-[0_10px_24px_rgba(15,23,42,0.22)] hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
            activeTab === "tasks" ? "bg-white/20 border border-white/30" : "bg-white/10 border border-white/20"
          }`}
          onClick={() => setActiveTab("tasks")}
          data-component="overtime-manager-tabs"
          data-feature="view_overtime_tasks"
        >
          Tasks
          <CheckBadgeIcon aria-hidden="true" className="-mr-0.5 size-4 sm:size-5" />

        </button>

        <button
          className={`inline-flex items-center gap-x-2 rounded-2xl px-2 py-2 sm:px-3.5 sm:py-2.5 text-xs sm:text-sm font-semibold text-white shadow-[0_10px_24px_rgba(15,23,42,0.22)] hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
            activeTab === "holidays" ? "bg-white/20 border border-white/30" : "bg-white/10 border border-white/20"
          }`}
          onClick={() => setActiveTab("holidays")}
          data-component="overtime-manager-tabs"
          data-feature="view_overtime_attendance"
        >
          Attendance
          <ClockIcon aria-hidden="true" className="-mr-0.5 size-4 sm:size-5" />

        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-5 px-2">
        {activeTab === "bids" && <Bids />}
        {activeTab === "tasks" && <TaskManagerRole date={overTime} />}
        {activeTab === "holidays" && <HolidayGraph />}
      </div>
    </div>

            
            </div>
            </div>
            

           
    );
}
